import type { LiveCounter } from "./live-counter";

const definitions = [
  { key: "rejected", label: "Reddedilen ürün", unit: "adet" },
  { key: "cylinders", label: "Silindir sayısı", unit: "adet" },
  { key: "cases", label: "Koli adedi", unit: "koli" },
] as const;

export function plcCounterPresentation(counter: LiveCounter | null, unavailable: boolean, now: number) {
  if (!counter?.configured) return [];
  return definitions.map(({ key, label, unit }) => {
    const metric = counter.plcCounters?.[key];
    const measured = typeof metric?.measuredAt === "string" ? Date.parse(metric.measuredAt) : NaN;
    const valid = metric != null && Number.isSafeInteger(metric.value) && metric.value >= 0 && metric.value <= 0xffffffff &&
      Number.isInteger(metric.register) && metric.register >= 0 && metric.register <= 65534 && Number.isFinite(measured);
    const fresh = valid && Math.abs(now - measured) <= 10_000;
    return {
      key, label, unit,
      value: valid && fresh && !unavailable ? metric.value : null,
      register: valid ? metric.register : null,
      measuredAt: valid ? metric.measuredAt : null,
      status: unavailable ? "Bağlantı kontrol edilmeli" : !valid ? "Ölçüm bekleniyor" : !fresh ? "Ölçüm gecikti" : "Güncel",
    };
  });
}
